module.exports = __webpack_public_path__ + "img/portrait-019.1060ffa3.jpg";